import { createContext, useContext, useState } from 'react';
import Modal from '../components/common/Modal';

const ModalContext = createContext(null);
export function ModalProvider({ children }) {
  const [stack, setStack] = useState([]); // <-- multiple modals

  const openModal = ({ title, content, size = "md", onClose }) => {
    setStack((prev) => [...prev, { title, content, size, onClose }]);
  };

  const closeModal = () => {
    setStack((prev) => prev.slice(0, -1)); // remove top modal only
  };
  const closeAllModals = () => {
    setStack([]); // <-- close ALL modals
  };
  const topModal = stack[stack.length - 1];

  const closeTopModal = () => {
    // Run any custom close handler for the top modal, then pop it.
    try {
      if (topModal && typeof topModal.onClose === "function") {
        topModal.onClose();
      }
    } catch (e) {
      // ignore modal onClose errors; still close the modal
    }
    setStack((prev) => prev.slice(0, -1));
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal, closeAllModals }}>
      {children}

      {topModal && (
        <Modal title={topModal.title} size={topModal.size} onClose={closeTopModal}>
          {topModal.content}
        </Modal>
      )}
    </ModalContext.Provider>
  );
}

/*
export function ModalProvider({ children }) {
  const [modalState, setModalState] = useState({ open: false, title: '', content: null, size: 'md' });

  const openModal = ({ title = '', content = null, size = 'md' }) => {
    setModalState({ open: true, title, content, size });
  };

  const closeModal = () => setModalState((s) => ({ ...s, open: false }));

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      {modalState.open && (
        <Modal title={modalState.title} size={modalState.size} onClose={closeModal}>
          {modalState.content}
        </Modal>
      )}
    </ModalContext.Provider>
  );
} */

export function useModal() {
  return useContext(ModalContext);
}

export default ModalContext;
